import React from 'react';
import './FeaturesSection.css';

const FeaturesSection: React.FC = () => {
  return (
    <section className="features-benefits-section">
      <h2>Empowering Your Business with Intelligent Checklists</h2>
      <p>CheckifAI offers a suite of features designed to enhance your operational efficiency and service quality.</p>
      <div className="features-grid">
        <div className="feature-item">
          <div className="feature-icon-placeholder"></div>
          <h3>Flexible Task Scheduling & Recurrence</h3>
          <p>Automate routine tasks and ensure critical operations are never missed with customizable recurrence patterns.</p>
        </div>
        <div className="feature-item">
          <div className="feature-icon-placeholder"></div>
          <h3>Real-time Progress Tracking</h3>
          <p>Monitor the completion status of tasks and checklists in real-time, providing immediate operational oversight.</p>
        </div>
        <div className="feature-item">
          <div className="feature-icon-placeholder"></div>
          <h3>Detailed Reporting & Analytics</h3>
          <p>Generate comprehensive reports on completed checklists to gain valuable insights into operational efficiency and compliance.</p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
